import { Component, EventEmitter, Input, Output } from '@angular/core';
import { isJsObject } from '@util/utils';

@Component({
  selector: 'app-montage-location',
  templateUrl: './montage-location.component.html'
})
export class MontageLocationComponent {

  _data: any = {};

  @Input() readonly = false;

  @Input() loctype = 1;

  @Input() set data(data: any) {
    if (isJsObject(data)) {
      this._data = data;
    }
  }

  @Input('address-length') addressLength: any;

  @Input('city-length') cityLength: any;

  @Input('zip-length') zipLength: any;

  @Output() change = new EventEmitter();

  onLocationChange($event: any) {
    this.change.emit($event);
  }
}
